// @flow
import React, { type Node, Fragment } from 'react';

import CSSSticky from 'app/common/ui-components/css-sticky';
import SimpleDate from 'app/dataProviders/SimpleDate';
import type { Discipline } from 'app/dataTypes/Discipline.types';

import TableSummaryHead from './TableSummaryHead';
import type { Period } from '../usePeriods';
import useSummaryMarks from './useSummaryMarks';
import TableSummaryContent from './TableSummaryContent';

import styles from './TableSummary.scss';


type Props = {
  periods: Array<Period>,
  date: SimpleDate,
  klassId: string,
  studentId: string,
  disciplines: Array<Discipline>,
  onUpdateDIsciplines: (Array<Discipline>) => void,
}

const TableSummary = ({
  periods,
  date,
  klassId,
  studentId,
  disciplines,
  onUpdateDIsciplines,
}: Props): Node => {
  const [summaryMarks, loading] = useSummaryMarks({ klassId, studentId, date }, onUpdateDIsciplines);

  return (
    <Fragment>
      <CSSSticky
        number={3}
        className={styles.stickable}
        shadowClassName={styles.shadow}
      >
        <TableSummaryHead periods={periods} />
      </CSSSticky>

      <TableSummaryContent
        periods={periods}
        disciplines={disciplines}
        summaryMarks={summaryMarks}
        loading={loading}
      />
    </Fragment>
  );
};

export default TableSummary;
